/* src/app/likert/likert.component.scss */
.likert-scale {
  width: auto;
  display: inline-block;
  justify-content: center;
}
.likert-scale .choices {
  display: flex;
  justify-content: center;
  border-collapse: collapse;
}
.likert-scale .choices .option-box + .option-box {
  border-left: 0;
}
.likert-scale .choices .option-box {
  width: 110px;
  height: 60px;
  font-size: 2rem;
  line-height: 60px;
  border: 1px solid #ccc;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
  user-select: none;
}
.likert-scale .choices .option-box:hover {
  background-color: darkgray;
  color: black;
}
.likert-scale .choices .option-box.highlighted {
  background-color: #6ccc09;
  color: white;
}
.likert-scale .labels {
  display: flex;
  margin-top: 3px;
  justify-content: space-between;
  width: 100%;
}
/*# sourceMappingURL=likert.component.css.map */
